import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { ospreyMatterWorkflowSchema } from '@repo/validation/schema_ospreyAPI'

const initialState = {
  workflows: {},
  clientMatterNo: null
}

export const useMatterWorkflowStore = storeWrapper('useMatterWorkflowStore', (set) => ({
  ...initialState,
  fetchMatterWorkflows: async ({ clientMatterNo }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchMatterWorkflows_${clientMatterNo}`,
        delay: 500,
        callback: async () => {
          const clientMatterNoParts = clientMatterNo.split('-')
          const clientNo = clientMatterNoParts[0]?.trim()
          const matterNo = clientMatterNoParts[clientMatterNoParts.length - 1]

          let fetchedMatterWorkflows

          try {
            fetchedMatterWorkflows =
              (await ospreyAPI({
                service: 'workflows',
                endpoint: 'MatterWorkflowWorkTypeTask/GetAllMatterWorkflowExtendedByClientNoAndMatterNo',
                data: { clientNo: clientNo, matterNo: matterNo },
                schema: ospreyMatterWorkflowSchema
              })) || {}
          } catch (error) {
            console.log('error', error)
            return
          }

          set({ workflows: fetchedMatterWorkflows })
          resolve(fetchedMatterWorkflows)
        }
      })
    })
  },
  getWorkflowLink: ({ clientNo, matterNo, actionLinkedTaskId, taskPositionIndex, workflowId, uniqueWorkflowCount }) => {
    return `/case-management/matters/workflows/run?area=3000&flag=3600&client_no=${clientNo}&matter_no=${matterNo}&task_id=${actionLinkedTaskId}&position=${taskPositionIndex}&wfid=${workflowId}&uid=${uniqueWorkflowCount}&excl=`
  },
  setWorkflows: (newWorkflows) => set({ workflows: newWorkflows }),
  reset: () => set(initialState)
}))
